export default class NewDJCPModel {
    constructor(data = {}) {
        this.cabecera = {
            departamento: data?.cabecera?.departamento || '',
            doc_id: data?.cabecera?.doc_id || '',
            doc_id_tipo: data?.cabecera?.doc_id_tipo
                ? parseInt(data?.cabecera?.doc_id_tipo)
                : 0,
            fecha: data?.cabecera?.fecha || null,
            fecha_Cierre: data?.cabecera?.fecha_Cierre || null,
            habilitada: data?.cabecera?.habilitada
                ? parseInt(data?.cabecera?.habilitada)
                : 0,
            id: data?.cabecera?.id ? parseInt(data?.cabecera?.id) : 0,
            numero: data?.cabecera?.numero
                ? parseInt(data?.cabecera?.numero)
                : 0,
            padrones: data?.cabecera?.padrones || '',
            razon_social: data?.cabecera?.razon_social || '',
            serie: data?.cabecera?.serie ? parseInt(data?.cabecera?.serie) : 0,
            telefono: data?.cabecera?.telefono || '',
            timbre: data?.cabecera?.timbre,
            titulares: data?.cabecera?.titulares || '',
            titulares_Documento: data?.cabecera?.titulares_Documento || null,
            total_Kilos: data?.cabecera?.total_Kilos
                ? parseInt(data?.cabecera?.total_Kilos)
                : 0,
            total_Superficie: data?.cabecera?.total_Superficie
                ? parseInt(data?.cabecera?.total_Superficie)
                : 0,
            ubicacion_X: data?.cabecera?.ubicacion_X
                ? parseInt(data?.cabecera?.ubicacion_X)
                : 0,
            ubicacion_Y: data?.cabecera?.ubicacion_Y
                ? parseInt(data?.cabecera?.ubicacion_Y)
                : 0,
            usuario: data?.cabecera?.usuario
                ? parseInt(data?.cabecera?.usuario)
                : 0,
            viniedo: data?.cabecera?.viniedo || '',
        };
        this.items = data.items || [];
    }
}
